import React from "react";
import AddItemModal from "./AddItemModal";
import Breadcrumb from "../../../components/Breadcrumb";
import { addSpecialtyDataAsync } from "../../../lib/common-service";
import { getUserCredential } from "../../../lib/cookies";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const AddSpecialty = ({ isVisible, onClose, onSave, breadcrumbData = {} }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cookiesData = getUserCredential();

  const fields = [
    {
      name: "specialty_name",
      label: "Specialty Name",
      type: "text",
      required: true,
      autoFocus: true,
      placeholder: "Enter Specialty Name",
      errorMessage: "Specialty name is required",
    },
    {
      name: "specialty_desc",
      label: "Description",
      type: "textarea",
      required: false,
      placeholder: "Enter Specialty Desc.",
      rows: 3,
    },
  ];

  const initialData = {
    specialty_name: "",
    specialty_desc: "",
  };

  const apiConfig = {
    fieldType: "specialty",
    endpoint: "/api/specialties", // Future API endpoint
    method: "POST",
  };

  const handleSave = async (data) => {
    // Format data for API call
    const bodyData = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_specialty_name: data.specialty_name,
      in_specialty_desc: data.specialty_desc || "",
      in_region_name: "",
    };

    try {
      // Make API call to add specialty
      const result = await addSpecialtyDataAsync(bodyData, history, dispatch);

      if (result) {
        // Create specialty object for parent component
        const newSpecialty = {
          text: data.specialty_name,
          id: data.specialty_name.toLowerCase().replace(/\s+/g, "_"),
          desc: data.specialty_desc || "",
        };

        // Call parent onSave function
        await onSave(newSpecialty);
        return true; // Success
      } else {
        return false; // API call failed
      }
    } catch (error) {
      console.error("Error adding specialty:", error);
      return false; // Error occurred
    }
  };

  // Render breadcrumb if context data is available
  const renderBreadcrumb = () => {
    const breadcrumbItems = [];

    if (breadcrumbData.division) {
      breadcrumbItems.push({
        id: "division",
        label: "Division",
        value: breadcrumbData.division,
      });
    }

    if (breadcrumbData.hospital) {
      breadcrumbItems.push({
        id: "hospital",
        label: "Hospital/Location",
        value: breadcrumbData.hospital,
      });
    }

    if (breadcrumbItems.length === 0) return null;

    return <Breadcrumb items={breadcrumbItems} />;
  };

  return (
    <AddItemModal
      isVisible={isVisible}
      onClose={onClose}
      onSave={handleSave}
      title="Add Specialty"
      fields={fields}
      initialData={initialData}
      apiConfig={apiConfig}
      breadcrumb={renderBreadcrumb()}
      width={500}
    />
  );
};

export default React.memo(AddSpecialty);
